import Layout from "../../../components/Layout";
import FormPutAluno from "../Formularios/formPutUser";

export default function PutAlunoAnamnese() {
  return Layout(FormPutAluno, "Anamnese");
}
